var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',_vm._b({attrs:{"disabled":_vm.disabled || _vm.loading,"loading":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.handleClick.apply(null, arguments)}}},'el-button',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }